import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy manager analytics URL - Anika WOMAC dashboard replaced Arthrosamid for managers. */
export const Route = createFileRoute("/_app/analytics/arthrosamid")({
    beforeLoad: () => {
        throw redirect({ to: "/analytics/anika" });
    },
});
